import { Instagram, MessageCircle, MapPin } from "lucide-react";
import { CONTACT, DEFAULT_MSG, waLink } from "../../lib/site";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/10 px-5 pb-10 pt-20 md:px-10" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px]">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <img src="/img/logo.png" alt="Carlos Motta Personal Trainer" className="h-auto w-56" data-testid="footer-logo" />
          <div className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400" data-testid="footer-cref">{CONTACT.cref}</div>
        </div>
        <div className="space-y-3 text-sm">
          <a href={waLink(DEFAULT_MSG)} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 text-zinc-300 transition-colors hover:text-[var(--red)]">
            <MessageCircle className="h-4 w-4" /> {CONTACT.whatsappLabel}
          </a>
          <a href={`https://instagram.com/${CONTACT.instagram}`} target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="flex items-center gap-3 text-zinc-300 transition-colors hover:text-[var(--red)]">
            <Instagram className="h-4 w-4" /> @{CONTACT.instagram}
          </a>
          <div className="flex items-center gap-3 text-zinc-300" data-testid="footer-location"><MapPin className="h-4 w-4" /> {CONTACT.city}</div>
        </div>
        <p className="text-sm leading-relaxed text-zinc-400 md:text-right">Personal presencial · Consultoria online · Consultoria mista</p>
      </div>
      <div className="mt-16 select-none font-display text-[18vw] font-900 uppercase leading-[0.8] text-outline">Motta</div>
      <div className="mt-6 flex flex-col justify-between gap-2 border-t border-white/10 pt-6 font-mono text-xs uppercase tracking-[0.15em] text-zinc-400 sm:flex-row">
        <span>© 2026 Carlos Motta Personal</span>
        <span>Treino com método</span>
      </div>
    </div>
  </footer>
);

export const FloatingWhatsApp = () => (
  <a href={waLink(DEFAULT_MSG)} target="_blank" rel="noreferrer" aria-label="Falar no WhatsApp" data-testid="floating-whatsapp-btn"
    className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-[#0a0a0c] shadow-[0_10px_30px_rgba(0,0,0,0.6)] transition-transform hover:scale-110">
    <MessageCircle className="h-6 w-6" />
  </a>
);
